"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailSelector = emailSelector;
function emailSelector(state) {
  return state.social.email || '';
}